module.exports = __webpack_public_path__ + "img/3.8f7fe6e5.png";